import { render, staticRenderFns } from "./tollbar.vue?vue&type=template&id=23d80085&scoped=true&"
import script from "./tollbar.vue?vue&type=script&lang=js&"
export * from "./tollbar.vue?vue&type=script&lang=js&"
import style0 from "./tollbar.vue?vue&type=style&index=0&id=23d80085&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23d80085",
  null
  
)

export default component.exports